import { MailboxInfo } from 'owa-client-ids';
import { RequestOptions } from '../types/RequestOptions';

export function getRequestOptionsOrDefault(mailboxInfo: MailboxInfo): RequestOptions {
    let defaultRequestOptions: RequestOptions = mailboxInfo.requestOptions;
    if (!defaultRequestOptions) {
        defaultRequestOptions = {
            headers: new Headers(),
        };
    }
    return defaultRequestOptions;
}
